import { c as _c } from "react/compiler-runtime";
import { EmptyStateChartIcon } from '@systemeio/icons';
import { MAIN_CHART_AREA_CLASS_NAME } from 'modules/main/constants/main-chart';
import { EmptyState } from 'shared/components/empty-states';
import { twJoin } from 'tailwind-merge';
interface MainChartEmptyStateProps {
  description?: string;
  title: string;
}
export const MainChartEmptyState = t0 => {
  const $ = _c(4);
  const {
    description,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = twJoin("flex", MAIN_CHART_AREA_CLASS_NAME);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== description || $[2] !== title) {
    t2 = <div className={t1}><EmptyState className="py-0" icon={EmptyStateChartIcon} title={title} description={description} /></div>;
    $[1] = description;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};